import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { apiBaseUrl } from '../config.js';

const AgentDashboard = ({ userToken }) => {
    const [tasaciones, setTasaciones] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalPages: 1,
        totalCount: 0
    });
    
    // Filters
    const getTodayDate = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    };
    
    const getTomorrowDate = () => {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        return tomorrow.toISOString().split('T')[0];
    };
    
    const [startDate, setStartDate] = useState(getTodayDate());
    const [endDate, setEndDate] = useState(getTomorrowDate());
    const [operationFilter, setOperationFilter] = useState('all');
    const [propertyFilter, setPropertyFilter] = useState('all');
    
    // Modal state
    const [selectedTasacion, setSelectedTasacion] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    
    const openModal = (tasacion) => {
        setSelectedTasacion(tasacion);
        setIsModalOpen(true);
    };
    
    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedTasacion(null);
    };
    
    const fetchTasaciones = async (page = 1) => {
        try {
            setLoading(true);
            
            const params = new URLSearchParams({
                page: page.toString(),
                limit: '20'
            });
            
            if (startDate) params.append('startDate', startDate);
            if (endDate) params.append('endDate', endDate);
            if (operationFilter !== 'all') params.append('operation', operationFilter);
            if (propertyFilter !== 'all') params.append('property', propertyFilter);
            
            const response = await axios.get(
                `${apiBaseUrl}/api/agent/tasaciones?${params.toString()}`,
                {
                    headers: {
                        'Authorization': `Bearer ${userToken}`
                    }
                }
            );
            
            setTasaciones(response.data.tasaciones || []);
            setPagination(response.data.pagination || {});
        } catch (error) {
            console.error('Error fetching agent tasaciones:', error);
            setTasaciones([]);
        } finally {
            setLoading(false);
        }
    };
    
    useEffect(() => {
        if (userToken) {
            fetchTasaciones();
        }
    }, [userToken, startDate, endDate, operationFilter, propertyFilter]);
    
    const handleNextPage = () => {
        if (pagination.hasNextPage) {
            fetchTasaciones(pagination.currentPage + 1);
        }
    };
    
    const handlePrevPage = () => {
        if (pagination.hasPrevPage) {
            fetchTasaciones(pagination.currentPage - 1);
        }
    };
    
    return (
        <div style={{ paddingRight: '20px', paddingLeft: '20px' }}>
            {/* Filters Section */}
            <div style={{
                background: 'white',
                padding: '20px',
                borderRadius: '12px',
                boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                marginBottom: '20px'
            }}>
                <h3 style={{ fontSize: '18px', marginBottom: '20px', color: '#2c3e50' }}>
                    🔍 Filtros
                </h3>
                
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' }}>
                    {/* Date From */}
                    <div>
                        <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#7f8c8d', fontWeight: '500' }}>
                            Desde
                        </label>
                        <input
                            type="date"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            style={{
                                width: '100%',
                                padding: '10px',
                                border: '2px solid #e9ecef',
                                borderRadius: '8px',
                                fontSize: '14px',
                                boxSizing: 'border-box'
                            }}
                        />
                    </div>
                    
                    {/* Date To */}
                    <div>
                        <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#7f8c8d', fontWeight: '500' }}>
                            Hasta
                        </label>
                        <input
                            type="date"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            style={{
                                width: '100%',
                                padding: '10px',
                                border: '2px solid #e9ecef',
                                borderRadius: '8px',
                                fontSize: '14px',
                                boxSizing: 'border-box'
                            }}
                        />
                    </div>
                    
                    {/* Operation Filter */}
                    <div>
                        <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#7f8c8d', fontWeight: '500' }}>
                            Operación
                        </label>
                        <select
                            value={operationFilter}
                            onChange={(e) => setOperationFilter(e.target.value)}
                            style={{
                                width: '100%',
                                padding: '10px',
                                border: '2px solid #e9ecef',
                                borderRadius: '8px',
                                fontSize: '14px',
                                boxSizing: 'border-box',
                                background: 'white'
                            }}
                        >
                            <option value="all">Todas</option>
                            <option value="venta">💰 Venta</option>
                            <option value="alquiler">🏠 Alquiler</option>
                        </select>
                    </div>
                    
                    {/* Property Type Filter */}
                    <div>
                        <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#7f8c8d', fontWeight: '500' }}>
                            Tipo de Propiedad
                        </label>
                        <select
                            value={propertyFilter}
                            onChange={(e) => setPropertyFilter(e.target.value)}
                            style={{
                                width: '100%',
                                padding: '10px',
                                border: '2px solid #e9ecef',
                                borderRadius: '8px',
                                fontSize: '14px',
                                boxSizing: 'border-box',
                                background: 'white'
                            }}
                        >
                            <option value="all">Todas</option>
                            <option value="departamento">🏢 Departamento</option>
                            <option value="casa">🏠 Casa</option>
                            <option value="oficina">💼 Oficina</option>
                            <option value="local">🏪 Local Comercial</option>
                            <option value="cocheras">🚗 Cocheras</option>
                        </select>
                    </div>
                </div>
            </div>
            
            {/* Tasaciones Table */}
            <div style={{
                background: 'white',
                padding: '20px',
                borderRadius: '12px',
                boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
            }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <h3 style={{ fontSize: '18px', color: '#2c3e50', margin: 0 }}>
                        📋 Mis Tasaciones ({pagination.totalCount || 0})
                    </h3>
                </div>
                
                {loading ? (
                    <div style={{ textAlign: 'center', padding: '40px', color: '#7f8c8d' }}>
                        Cargando...
                    </div>
                ) : tasaciones.length === 0 ? (
                    <div style={{ textAlign: 'center', padding: '40px', color: '#7f8c8d' }}>
                        No hay tasaciones disponibles
                    </div>
                ) : (
                    <>
                        <div style={{ overflowX: 'auto' }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead>
                                    <tr style={{ background: '#f8f9fa', borderBottom: '2px solid #dee2e6' }}>
                                        <th style={{ padding: '12px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: '#495057', textTransform: 'uppercase' }}>
                                            Fecha
                                        </th>
                                        <th style={{ padding: '12px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: '#495057', textTransform: 'uppercase' }}>
                                            Dirección
                                        </th>
                                        <th style={{ padding: '12px', textAlign: 'center', fontSize: '12px', fontWeight: '600', color: '#495057', textTransform: 'uppercase' }}>
                                            Operación
                                        </th>
                                        <th style={{ padding: '12px', textAlign: 'center', fontSize: '12px', fontWeight: '600', color: '#495057', textTransform: 'uppercase' }}>
                                            Tipo
                                        </th>
                                        <th style={{ padding: '12px', textAlign: 'center', fontSize: '12px', fontWeight: '600', color: '#495057', textTransform: 'uppercase' }}>
                                            Rango de Precio
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tasaciones.map((tasacion) => (
                                        <tr 
                                            key={tasacion._id} 
                                            onClick={() => openModal(tasacion)}
                                            style={{ 
                                                borderBottom: '1px solid #e9ecef',
                                                cursor: 'pointer',
                                                transition: 'background-color 0.2s'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                        >
                                            <td style={{ padding: '12px', fontSize: '13px', color: '#495057' }}>
                                                {new Date(tasacion.timestamp).toLocaleString('es-AR', {
                                                    year: 'numeric',
                                                    month: '2-digit',
                                                    day: '2-digit',
                                                    hour: '2-digit',
                                                    minute: '2-digit'
                                                })}
                                            </td>
                                            <td style={{ padding: '12px', maxWidth: '250px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={tasacion.address}>
                                                {tasacion.address}
                                            </td>
                                            <td style={{ padding: '12px', textAlign: 'center' }}>
                                                <span style={{
                                                    padding: '4px 12px',
                                                    borderRadius: '12px',
                                                    fontSize: '12px',
                                                    fontWeight: 'bold',
                                                    backgroundColor: tasacion.operation === 'alquiler' ? '#e3f2fd' : '#f3e5f5',
                                                    color: tasacion.operation === 'alquiler' ? '#1976d2' : '#7b1fa2'
                                                }}>
                                                    {tasacion.operation === 'alquiler' ? '🏠 Alquiler' : '💰 Venta'}
                                                </span>
                                            </td>
                                            <td style={{ padding: '12px', textAlign: 'center', fontSize: '13px', color: '#495057' }}>
                                                {tasacion.property === 'departamento' && '🏢 Departamento'}
                                                {tasacion.property === 'casa' && '🏠 Casa'}
                                                {tasacion.property === 'oficina' && '💼 Oficina'}
                                                {tasacion.property === 'local' && '🏪 Local'}
                                                {tasacion.property === 'cocheras' && '🚗 Cocheras'}
                                                {!['departamento', 'casa', 'oficina', 'local', 'cocheras'].includes(tasacion.property) && tasacion.property}
                                            </td>
                                            <td style={{ 
                                                padding: '12px', 
                                                textAlign: 'center', 
                                                fontWeight: '600', 
                                                color: '#27ae60',
                                                fontSize: '13px'
                                            }}>
                                                {tasacion.priceRange}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        
                        {/* Pagination */}
                        {pagination.totalPages > 1 && (
                            <div style={{
                                marginTop: '20px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                gap: '10px'
                            }}>
                                <button
                                    onClick={handlePrevPage}
                                    disabled={!pagination.hasPrevPage}
                                    style={{
                                        padding: '8px 16px',
                                        background: pagination.hasPrevPage ? '#667eea' : '#e9ecef',
                                        color: pagination.hasPrevPage ? 'white' : '#adb5bd',
                                        border: 'none',
                                        borderRadius: '6px',
                                        cursor: pagination.hasPrevPage ? 'pointer' : 'not-allowed',
                                        fontSize: '14px'
                                    }}
                                >
                                    ← Anterior
                                </button>
                                
                                <span style={{ fontSize: '14px', color: '#495057' }}>
                                    Página {pagination.currentPage} de {pagination.totalPages}
                                </span>
                                
                                <button
                                    onClick={handleNextPage}
                                    disabled={!pagination.hasNextPage}
                                    style={{
                                        padding: '8px 16px',
                                        background: pagination.hasNextPage ? '#667eea' : '#e9ecef',
                                        color: pagination.hasNextPage ? 'white' : '#adb5bd',
                                        border: 'none',
                                        borderRadius: '6px',
                                        cursor: pagination.hasNextPage ? 'pointer' : 'not-allowed',
                                        fontSize: '14px'
                                    }}
                                >
                                    Siguiente →
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>
            
            {/* Tasacion Detail Modal */}
            {isModalOpen && selectedTasacion && (
                <div 
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        alignItems: 'flex-start',
                        justifyContent: 'center',
                        zIndex: 9999,
                        padding: '40px 10px',
                        overflowY: 'auto'
                    }}
                    onClick={closeModal}
                >
                    <div 
                        style={{
                            backgroundColor: 'white',
                            borderRadius: '16px',
                            maxWidth: '700px',
                            width: '100%',
                            maxHeight: '70vh',
                            display: 'flex',
                            flexDirection: 'column',
                            boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
                            position: 'relative',
                            overflow: 'hidden',
                            marginBottom: '40px'
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Modal Header */}
                        <div style={{
                            background: 'linear-gradient(135deg, #667eea, #764ba2)',
                            color: 'white',
                            padding: '25px 30px',
                            borderTopLeftRadius: '16px',
                            borderTopRightRadius: '16px',
                            position: 'relative',
                            flexShrink: 0
                        }}>
                            <h2 style={{ 
                                margin: 0, 
                                fontSize: '24px', 
                                fontWeight: '700',
                                paddingRight: '40px'
                            }}>
                                📋 Detalles de Tasación
                            </h2>
                            <button
                                onClick={closeModal}
                                style={{
                                    position: 'absolute',
                                    top: '20px',
                                    right: '20px',
                                    background: 'rgba(255,255,255,0.2)',
                                    border: 'none',
                                    color: 'white',
                                    fontSize: '24px',
                                    width: '36px',
                                    height: '36px',
                                    borderRadius: '50%',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    transition: 'all 0.3s'
                                }}
                                onMouseEnter={(e) => e.target.style.background = 'rgba(255,255,255,0.3)'}
                                onMouseLeave={(e) => e.target.style.background = 'rgba(255,255,255,0.2)'}
                            >
                                ×
                            </button>
                        </div>
                        
                        {/* Modal Content */}
                        <div style={{ 
                            padding: '30px 30px 60px 30px',
                            overflowY: 'auto',
                            flex: 1,
                            WebkitOverflowScrolling: 'touch'
                        }}>
                            {/* Date and Time */}
                            <div style={{ 
                                marginBottom: '25px',
                                paddingBottom: '20px',
                                borderBottom: '2px solid #e9ecef'
                            }}>
                                <div style={{ 
                                    fontSize: '14px', 
                                    color: '#7f8c8d',
                                    marginBottom: '5px'
                                }}>
                                    📅 Fecha y Hora
                                </div>
                                <div style={{ fontSize: '16px', color: '#2c3e50', fontWeight: '600' }}>
                                    {new Date(selectedTasacion.timestamp).toLocaleString('es-AR', {
                                        weekday: 'long',
                                        year: 'numeric',
                                        month: 'long',
                                        day: 'numeric',
                                        hour: '2-digit',
                                        minute: '2-digit'
                                    })}
                                </div>
                            </div>
                            
                            {/* Property Details */}
                            <div style={{ 
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                                gap: '20px',
                                marginBottom: '25px'
                            }}>
                                {/* Address */}
                                <div style={{ 
                                    background: '#f8f9fa',
                                    padding: '20px',
                                    borderRadius: '12px',
                                    gridColumn: '1 / -1'
                                }}>
                                    <div style={{ 
                                        fontSize: '14px', 
                                        color: '#7f8c8d',
                                        marginBottom: '8px'
                                    }}>
                                        📍 Dirección
                                    </div>
                                    <div style={{ 
                                        fontSize: '18px', 
                                        color: '#2c3e50', 
                                        fontWeight: '600',
                                        wordBreak: 'break-word'
                                    }}>
                                        {selectedTasacion.address}
                                    </div>
                                </div>
                                
                                {/* Operation */}
                                <div style={{ 
                                    background: '#f8f9fa',
                                    padding: '20px',
                                    borderRadius: '12px'
                                }}>
                                    <div style={{ 
                                        fontSize: '14px', 
                                        color: '#7f8c8d',
                                        marginBottom: '8px'
                                    }}>
                                        💼 Operación
                                    </div>
                                    <div>
                                        <span style={{
                                            padding: '6px 16px',
                                            borderRadius: '12px',
                                            fontSize: '14px',
                                            fontWeight: 'bold',
                                            backgroundColor: selectedTasacion.operation === 'alquiler' ? '#e3f2fd' : '#f3e5f5',
                                            color: selectedTasacion.operation === 'alquiler' ? '#1976d2' : '#7b1fa2',
                                            display: 'inline-block'
                                        }}>
                                            {selectedTasacion.operation === 'alquiler' ? '🏠 Alquiler' : '💰 Venta'}
                                        </span>
                                    </div>
                                </div>
                                
                                {/* Property Type */}
                                <div style={{ 
                                    background: '#f8f9fa',
                                    padding: '20px',
                                    borderRadius: '12px'
                                }}>
                                    <div style={{ 
                                        fontSize: '14px', 
                                        color: '#7f8c8d',
                                        marginBottom: '8px'
                                    }}>
                                        🏢 Tipo de Propiedad
                                    </div>
                                    <div style={{ 
                                        fontSize: '16px', 
                                        color: '#2c3e50', 
                                        fontWeight: '600'
                                    }}>
                                        {selectedTasacion.property === 'departamento' && '🏢 Departamento'}
                                        {selectedTasacion.property === 'casa' && '🏠 Casa'}
                                        {selectedTasacion.property === 'oficina' && '💼 Oficina'}
                                        {selectedTasacion.property === 'local' && '🏪 Local'}
                                        {selectedTasacion.property === 'cocheras' && '🚗 Cocheras'}
                                        {!['departamento', 'casa', 'oficina', 'local', 'cocheras'].includes(selectedTasacion.property) && selectedTasacion.property}
                                    </div>
                                </div>
                            </div>
                            
                            {/* Price Range - Highlighted */}
                            <div style={{ 
                                background: 'linear-gradient(135deg, #d4edda, #c3e6cb)',
                                padding: '25px',
                                borderRadius: '12px',
                                marginBottom: '25px',
                                border: '2px solid #28a745'
                            }}>
                                <div style={{ 
                                    fontSize: '14px', 
                                    color: '#155724',
                                    marginBottom: '8px',
                                    fontWeight: '600'
                                }}>
                                    💵 Rango de Precio
                                </div>
                                <div style={{ 
                                    fontSize: '24px', 
                                    color: '#155724', 
                                    fontWeight: '700'
                                }}>
                                    {selectedTasacion.priceRange}
                                </div>
                            </div>
                            
                            {/* Zone */}
                            {selectedTasacion.zone && selectedTasacion.zone !== 'N/A' && (
                                <div style={{ 
                                    background: '#f8f9fa',
                                    padding: '20px',
                                    borderRadius: '12px',
                                    marginBottom: '20px'
                                }}>
                                    <div style={{ 
                                        fontSize: '14px', 
                                        color: '#7f8c8d',
                                        marginBottom: '8px'
                                    }}>
                                        🗺️ Zona
                                    </div>
                                    <div style={{ 
                                        fontSize: '16px', 
                                        color: '#2c3e50', 
                                        fontWeight: '600'
                                    }}>
                                        {selectedTasacion.zone}
                                    </div>
                                </div>
                            )}
                            
                            {/* Valuation Type Badge */}
                            {selectedTasacion.valuationType && (
                                <div style={{ marginBottom: '20px' }}>
                                    <span style={{
                                        padding: '8px 16px',
                                        borderRadius: '8px',
                                        fontSize: '13px',
                                        fontWeight: '600',
                                        backgroundColor: selectedTasacion.valuationType === 'advanced' ? '#fff3cd' : '#d1ecf1',
                                        color: selectedTasacion.valuationType === 'advanced' ? '#856404' : '#0c5460',
                                        border: selectedTasacion.valuationType === 'advanced' ? '1px solid #ffc107' : '1px solid #17a2b8'
                                    }}>
                                        {selectedTasacion.valuationType === 'advanced' ? '⭐ Tasación Avanzada' : '📋 Tasación Básica'}
                                    </span>
                                </div>
                            )}
                            
                            {/* Property Details - Show if available */}
                            {(selectedTasacion.amb || selectedTasacion.garage || selectedTasacion.sc || selectedTasacion.st || selectedTasacion.sd || selectedTasacion.sterre) && (
                                <div style={{ marginBottom: '25px' }}>
                                    <h4 style={{ 
                                        fontSize: '16px', 
                                        color: '#2c3e50', 
                                        marginBottom: '15px',
                                        fontWeight: '700',
                                        borderBottom: '2px solid #e9ecef',
                                        paddingBottom: '10px'
                                    }}>
                                        🏗️ Detalles de la Propiedad
                                    </h4>
                                    <div style={{ 
                                        display: 'grid',
                                        gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                                        gap: '15px'
                                    }}>
                                        {selectedTasacion.amb && (
                                            <div style={{ 
                                                background: '#f8f9fa',
                                                padding: '15px',
                                                borderRadius: '8px'
                                            }}>
                                                <div style={{ fontSize: '12px', color: '#7f8c8d', marginBottom: '5px' }}>
                                                    🚪 Ambientes
                                                </div>
                                                <div style={{ fontSize: '18px', color: '#2c3e50', fontWeight: '600' }}>
                                                    {selectedTasacion.amb}
                                                </div>
                                            </div>
                                        )}
                                        
                                        {selectedTasacion.garage && (
                                            <div style={{ 
                                                background: '#f8f9fa',
                                                padding: '15px',
                                                borderRadius: '8px'
                                            }}>
                                                <div style={{ fontSize: '12px', color: '#7f8c8d', marginBottom: '5px' }}>
                                                    🚗 Cocheras
                                                </div>
                                                <div style={{ fontSize: '18px', color: '#2c3e50', fontWeight: '600' }}>
                                                    {selectedTasacion.garage}
                                                </div>
                                            </div>
                                        )}
                                        
                                        {selectedTasacion.sc && (
                                            <div style={{ 
                                                background: '#f8f9fa',
                                                padding: '15px',
                                                borderRadius: '8px'
                                            }}>
                                                <div style={{ fontSize: '12px', color: '#7f8c8d', marginBottom: '5px' }}>
                                                    📐 Sup. Cubierta
                                                </div>
                                                <div style={{ fontSize: '18px', color: '#2c3e50', fontWeight: '600' }}>
                                                    {selectedTasacion.sc} m²
                                                </div>
                                            </div>
                                        )}
                                        
                                        {selectedTasacion.st && (
                                            <div style={{ 
                                                background: '#f8f9fa',
                                                padding: '15px',
                                                borderRadius: '8px'
                                            }}>
                                                <div style={{ fontSize: '12px', color: '#7f8c8d', marginBottom: '5px' }}>
                                                    📏 Sup. Total
                                                </div>
                                                <div style={{ fontSize: '18px', color: '#2c3e50', fontWeight: '600' }}>
                                                    {selectedTasacion.st} m²
                                                </div>
                                            </div>
                                        )}
                                        
                                        {selectedTasacion.sd && (
                                            <div style={{ 
                                                background: '#f8f9fa',
                                                padding: '15px',
                                                borderRadius: '8px'
                                            }}>
                                                <div style={{ fontSize: '12px', color: '#7f8c8d', marginBottom: '5px' }}>
                                                    🏠 Sup. Descubierta
                                                </div>
                                                <div style={{ fontSize: '18px', color: '#2c3e50', fontWeight: '600' }}>
                                                    {selectedTasacion.sd} m²
                                                </div>
                                            </div>
                                        )}
                                        
                                        {selectedTasacion.sterre && (
                                            <div style={{ 
                                                background: '#f8f9fa',
                                                padding: '15px',
                                                borderRadius: '8px'
                                            }}>
                                                <div style={{ fontSize: '12px', color: '#7f8c8d', marginBottom: '5px' }}>
                                                    🌳 Sup. Terreno
                                                </div>
                                                <div style={{ fontSize: '18px', color: '#2c3e50', fontWeight: '600' }}>
                                                    {selectedTasacion.sterre} m²
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                            
                            {/* Condition and Age */}
                            {(selectedTasacion.condition || selectedTasacion.antiguedad) && (
                                <div style={{ 
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                                    gap: '15px',
                                    marginBottom: '25px'
                                }}>
                                    {selectedTasacion.condition && (
                                        <div style={{ 
                                            background: '#f8f9fa',
                                            padding: '20px',
                                            borderRadius: '12px'
                                        }}>
                                            <div style={{ 
                                                fontSize: '14px', 
                                                color: '#7f8c8d',
                                                marginBottom: '8px'
                                            }}>
                                                ⚙️ Condición
                                            </div>
                                            <div style={{ 
                                                fontSize: '16px', 
                                                color: '#2c3e50', 
                                                fontWeight: '600'
                                            }}>
                                                {selectedTasacion.condition}
                                            </div>
                                        </div>
                                    )}
                                    
                                    {selectedTasacion.antiguedad && (
                                        <div style={{ 
                                            background: '#f8f9fa',
                                            padding: '20px',
                                            borderRadius: '12px'
                                        }}>
                                            <div style={{ 
                                                fontSize: '14px', 
                                                color: '#7f8c8d',
                                                marginBottom: '8px'
                                            }}>
                                                📅 Antigüedad
                                            </div>
                                            <div style={{ 
                                                fontSize: '16px', 
                                                color: '#2c3e50', 
                                                fontWeight: '600'
                                            }}>
                                                {selectedTasacion.antiguedad} años
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                            
                            {/* Amenities */}
                            {(selectedTasacion.barbecue || selectedTasacion.pool || selectedTasacion.sum) && (
                                <div style={{ marginBottom: '25px' }}>
                                    <h4 style={{ 
                                        fontSize: '16px', 
                                        color: '#2c3e50', 
                                        marginBottom: '15px',
                                        fontWeight: '700',
                                        borderBottom: '2px solid #e9ecef',
                                        paddingBottom: '10px'
                                    }}>
                                        ✨ Comodidades
                                    </h4>
                                    <div style={{ 
                                        display: 'flex',
                                        gap: '10px',
                                        flexWrap: 'wrap'
                                    }}>
                                        {selectedTasacion.barbecue && (
                                            <span style={{
                                                padding: '8px 16px',
                                                background: '#d4edda',
                                                color: '#155724',
                                                borderRadius: '20px',
                                                fontSize: '14px',
                                                fontWeight: '600',
                                                border: '1px solid #c3e6cb'
                                            }}>
                                                🍖 Parrilla
                                            </span>
                                        )}
                                        {selectedTasacion.pool && (
                                            <span style={{
                                                padding: '8px 16px',
                                                background: '#d1ecf1',
                                                color: '#0c5460',
                                                borderRadius: '20px',
                                                fontSize: '14px',
                                                fontWeight: '600',
                                                border: '1px solid #bee5eb'
                                            }}>
                                                🏊 Piscina
                                            </span>
                                        )}
                                        {selectedTasacion.sum && (
                                            <span style={{
                                                padding: '8px 16px',
                                                background: '#fff3cd',
                                                color: '#856404',
                                                borderRadius: '20px',
                                                fontSize: '14px',
                                                fontWeight: '600',
                                                border: '1px solid #ffeaa7'
                                            }}>
                                                🏖️ Quincho/SUM
                                            </span>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                        
                        {/* Modal Footer */}
                        <div style={{
                            padding: '20px 30px',
                            background: '#f8f9fa',
                            borderBottomLeftRadius: '16px',
                            borderBottomRightRadius: '16px',
                            borderTop: '1px solid #e9ecef',
                            display: 'flex',
                            justifyContent: 'flex-end',
                            flexShrink: 0
                        }}>
                            <button
                                onClick={closeModal}
                                style={{
                                    padding: '12px 30px',
                                    background: '#667eea',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '8px',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s'
                                }}
                                onMouseEnter={(e) => e.target.style.background = '#5a6fd8'}
                                onMouseLeave={(e) => e.target.style.background = '#667eea'}
                            >
                                Cerrar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AgentDashboard;


